module.exports = __webpack_public_path__ + "img/pole-gray.51367209.png";